export class ColorCodeTranslator {
  from(bean: string): string {
    return (bean && bean.match(/^[0-9a-fA-F]{6}$/))
      ? ("#" + bean)
      : bean;
  }
  to(object: string): string {
    return (object && object.match(/^#[0-9a-fA-F]{6}$/))
      ? object.substring(1).toLowerCase()
      : object;
  }
}
